import styled, { css } from "styled-components";

export enum StatusColorType {
    Success = "--color-success",
    Error = "--color-error",
    Warning = "--color-warning",
    Info = "--color-info",
}

export const StyledStatus = styled.span<{ $color: StatusColorType; $noBullet: boolean }>`
    font-size: var(--size-14);
    font-weight: bold;
    white-space: nowrap;

    ${({ $noBullet }) =>
        !$noBullet &&
        css`
            &::before {
                display: inline-block;
                width: 6px;
                height: 6px;
                margin-right: 5px;
                content: "";
                border-radius: var(--radius-50);
                margin-bottom: 2px;
            }
        `}

    ${({ $color }) => {
        return css`
            color: var(${$color});
            &::before {
                background-color: var(${$color});
            }
        `;
    }}
`;
